import { Modal } from "antd";
import ContentDetailScheduleTime from "../ContentDetailScheduleTime";
import { useMemo } from "react";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const ModalDetailTimeSchedule = ({
  hideDetailTime,
  setAvailabilityFn,
  adminName,
  data,
  open,
  refetch,
  showEditModal,
  scheduleStatuses,
  scheduleStatusesLocale,
  onScheduleRowPatch,
}) => {
  const { t } = useTranslation();
  const detailTitleScheduleTime = useMemo(() => {
    if (!data?.date) return null;
    return (
      <div className="border-b border-neutral-100 pb-4 -mt-1">
        <p className="mb-0.5 text-xs font-medium uppercase tracking-wide text-neutral-500">
          {dayjs(data.date).format("YYYY")}
        </p>
        <p className="mb-1 text-2xl font-semibold leading-tight text-neutral-900">
          {dayjs(data.date).format("dddd, MMM D")}
        </p>
        <div className="flex items-baseline justify-between gap-4">
          <p className="mb-0 text-sm text-neutral-600">
            {t("meeting_management.at")}{" "}
            <span className="font-medium text-neutral-800">
              {dayjs(data?.start_time, "HH:mm:ss").format("HH:mm")} –{" "}
              {dayjs(data?.end_time, "HH:mm:ss").format("HH:mm")}
            </span>
          </p>
          {data?.creator_admin && (
            <p className="mb-0 shrink-0 text-xs text-neutral-400">
              {t("meeting_management.created_by")}:{" "}
              <span className="text-neutral-500">{data.creator_admin}</span>
            </p>
          )}
        </div>
      </div>
    );
  }, [data, t]);

  return (
    <Modal
      title={detailTitleScheduleTime}
      footer={null}
      onCancel={hideDetailTime}
      open={Boolean(open)}
      destroyOnHidden
      width={680}
      classNames={{ body: "pt-2" }}
    >
      <ContentDetailScheduleTime
        data={data}
        hideDetailScheduleTime={hideDetailTime}
        setAvailabilityFn={setAvailabilityFn}
        agent={adminName}
        refetch={refetch}
        showEditModal={showEditModal}
        scheduleStatuses={scheduleStatuses}
        scheduleStatusesLocale={scheduleStatusesLocale}
        onScheduleRowPatch={onScheduleRowPatch}
      />
    </Modal>
  );
};

export default ModalDetailTimeSchedule;
